import React from 'react';
import { useTranslation } from 'react-i18next';
import BlockTabs from '../../BlockTabs';
import { Loader } from '../../components';
import StackedPercentageAreaChart from '../../charts/StackedPercentageAreaChart';
import { useGetDashboardSdkVersionByDayQuery } from '../../../api/dashboardApiSlice';
import { dataToStackChartData } from '../../../services/data/charts/dataToStackChartData';

const DevicePerSdkVersionEvolution = ({filter, ...props}) => {
  const { t } = useTranslation();
  const {data = [], isSuccess, isError, refetch} = useGetDashboardSdkVersionByDayQuery({filter})
  const loaderProps = { success: isSuccess, error: isError, retry: refetch }
  const iosData = dataToStackChartData("sdk_version")(data.filter( (x)=>(x.os === "ios" )))
  const androidData = dataToStackChartData("sdk_version")(data.filter( (x)=>(x.os === "android" )))

  return (
    <BlockTabs title={t('version.device_per_sdk_version_evolution')} defaultActiveKey="android" {...props}>
      <Loader {...loaderProps} minHeight={"100%"} key="ios" title="ios">
        <StackedPercentageAreaChart  data={iosData} legendOptions={{show: false}} />
      </Loader>
      <Loader {...loaderProps} minHeight={"100%"} key="android" title="android">
        <StackedPercentageAreaChart  data={androidData} legendOptions={{show: false}} />
      </Loader>
    </BlockTabs>
  )
}

export default DevicePerSdkVersionEvolution
